<template>
  <el-select
    v-model="settlementType"
    @change="change"
    clearable

    placeholder="结算方式">
    <el-option
      v-for="item in settlementTypeList"
      :label="item.label"
      :value="item.value"
      :key="item.vadue" />
  </el-select>
</template>

<script>
import {settlementTypeList} from '@/const/settlement-type.js'

export default {
  props: ['modelValue'],
  emits: ['update:modelValue', 'change'],
  data () {
    return {
      settlementType: this.modelValue,
      settlementTypeList,
    }
  },
  watch: {
    modelValue (newVal) {
      if (this.settlementType === newVal) return
      this.settlementType = newVal
      this.change(newVal)
    }
  },
  methods: {
    change (item) {
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    },
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>
